
<app-auth [isAtLeastMedium]="isAtLeastMedium">
  <div layout-body>
              <div (keypress)="pressEnter($event)">

            <form novalidate class="mb-5" name="Fuser">
              <div class="login-content">
                <div class="connect py-1">
                  <div class="icon-box info"><i class="fa fa-arrow-right small-icon"></i></div>
                  <div class="header-content mt-4">
                      <div class="title-connect">Se connecter</div>
                  </div>
                </div>
                  <div class="fields">
                      <stInput type="text" innerId="username" name="user" autofocus="" autocomplete="username" placeholder="Votre login"
                        [(ngModel)]="userCredentials.login" (change)="resetErrorMessage()"
                        [isInvalid]="msg.errorConnection == true" class="custom-placeholder"></stInput>
                      <div class="login">
                        <stInput type="password" innerId="password" name="password" autocomplete="current-password" placeholder="********"
                          [(ngModel)]="userCredentials.password" (change)="resetErrorMessage()"
                          [isInvalid]="msg.errorConnection == true" class="custom-placeholder login"></stInput>
                      </div>
                      <div class="btn-full-width w-100 custom-primary" (click)="validate()">
                        <stButton btnLabel="Se connecter" btnClass="btn-color"></stButton>
                      </div>

                  </div>

                  <div class="text-center">
                    <a class="btn-forget-pwd" routerLink="/forgot-password">
                      Mot de passe oublié
                    </a>
                  </div>
              </div>
            </form>

          </div>
  </div>
</app-auth>


